/*
 * File: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice\src\Utils\Request.utils.ts
 * Project: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice
 * Created Date: Friday June 30th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Monday, 3rd June 2024 10:43:24
 * Modified By: Simon (s.gourlet@autobuy.fr>)
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 */

import buildUrl from "build-url-ts";
import Cookie from "Cookies/CookieWrapper";
import CookiePathResolver from "Config/Cookies/CookiePathResolver";
import { QueryParams } from "Types/queryParams";
import generalQueryParams from "./params.type";

function buildURL(params: generalQueryParams, url: string) {
    const queryParams: QueryParams = {};
    if (params.page && params.page > 0)
        queryParams.page = params.page.toString();

    for (let key of Object.keys(params))
        if (key == "perPage")
            queryParams["per_page"] = queryParams[key];
        else if (!["page"].includes(key) && params[key] !== undefined)
            queryParams[key] = params[key]!.toString();
    let newUrl = buildUrl(`${url}`, {queryParams});
    if (newUrl == undefined)
        throw new Error(`Not able to build url from ${JSON.stringify(params)}${url}`);
    return newUrl;
};

function buildAxiosHeader() {
    const token = Cookie.getCookie(CookiePathResolver.USER.TOKEN);
    const basicHeader = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `BEARER ${token}`
        }
    };
    return basicHeader;
};

function buildAxiosHeaderFile() {
    const token = Cookie.getCookie(CookiePathResolver.USER.TOKEN);
    const basicHeader = {
        headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `BEARER ${token}`
        }
    };
    return basicHeader;
};

export function fromBlobResponseToDownload(response: {
    blob: Blob;
    dispo: any;
    type: any;
}) {
    const url = window.URL.createObjectURL(
        new Blob([response.blob]),
      );
      const link = document.createElement('a');
      link.href = url;
      link.type = response.type;
      let filename = response.dispo.split("=")[1]
      link.setAttribute(
        'download',
        filename.replaceAll("\"", ""),
      );

      // Append to html link element page
      document.body.appendChild(link);

      // Start download
      link.click();

      // Clean up and remove the link
      link.parentNode!.removeChild(link);
}

export function InitRequestParams(url: string) {
    let page = 1;
    let orderedby = "";
    let per_page = 20;
    if (url !== "") {
        const mySearchParams = new URL(url).searchParams;
        if (mySearchParams.has("page"))
            page = parseInt(mySearchParams.get('page')!);
        if (mySearchParams.has('orderedby'))
            orderedby = mySearchParams.get('orderedby')!;
    }
    return { page, orderedby, per_page };
};

export function InitSellRequestParams(url: string)  {
    let page = 1;
    let orderedby = "";
    let perPage = 20;
    let myRet: any = {page: 1, orderedby: "", perPage: 20};
    const mySearchParams = new URL(url).searchParams;
    if (mySearchParams.has("page"))
        myRet.page = parseInt(mySearchParams.get('page')!);
    if (mySearchParams.has('orderedby'))
        myRet.orderedby = mySearchParams.get('orderedby')!;
    if (mySearchParams.has('per_page'))
        myRet.perPage = parseInt(mySearchParams.get('per_page')!);
    return {...myRet, skip: -1};
}

export function FromRefTime (since?: string) {
    let refTime = new Date(Date.now());
    switch (since) {
        case "day":
            refTime.setHours(0,0,0,0);
            break;
        case "week":
            refTime.setDate(refTime.getDate() - refTime.getDay() + 1);
            refTime.setHours(0,0,0,0);
            break;
        case "month":
            refTime.setDate(1);
            refTime.setHours(0,0,0,0);
            break;
        case "year":
            refTime.setFullYear(refTime.getFullYear(), 0, 1);
            refTime.setHours(0,0,0,0);
            break;
        case "all":
            refTime = new Date(0);
            break;
        default:
            if (since && !isNaN(parseInt(since))) {
                refTime = new Date(parseInt(since));
            }
            break;
    }

    return refTime.getTime().toString();
};

export {buildURL, buildAxiosHeader, buildAxiosHeaderFile};
